import React from 'react'
import { Filter, ListChecks, PenLine, Printer } from 'lucide-react'
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll'

const STEPS = [
  { step: 1, title: 'Filtre pela BNCC', description: 'Disciplina, série, tópico e dificuldade. São 729+ subtópicos mapeados.', icon: Filter },
  { step: 2, title: 'Escolha as questões', description: 'Adicione do banco curado ou escreva as suas. Tudo editável.', icon: ListChecks },
  { step: 3, title: 'Personalize a prova', description: 'Cabeçalho da escola, template, ordem das questões, gabarito.', icon: PenLine },
  { step: 4, title: 'Imprima o PDF', description: 'Diagramado, com gabarito separado. Pronto pra sala em um clique.', icon: Printer },
]

const ComoFuncionaSection: React.FC = () => {
  const revealRef = useRevealOnScroll<HTMLDivElement>()

  return (
    <section
      id="como-funciona"
      className="py-20 bg-surface dark:bg-ink-900"
      aria-labelledby="como-funciona-titulo"
    >
      <div ref={revealRef} className="container mx-auto px-4">
        <div data-reveal-item className="text-center mb-16 max-w-3xl mx-auto">
          <p className="flex items-center justify-center gap-3 font-mono text-caderno-xs uppercase tracking-widest text-ink-400 dark:text-ink-300 mb-4">
            <span className="text-terra-500">02</span>
            <span aria-hidden="true" className="w-8 h-px bg-cream-400 dark:bg-ink-500" />
            Como funciona
          </p>
          <h2
            id="como-funciona-titulo"
            className="text-3xl md:text-4xl font-display text-ink-900 dark:text-cream-50 mb-4"
          >
            Do filtro ao PDF em <span className="italic font-normal text-terra-500">quatro passos</span>.
          </h2>
          <p className="text-xl text-ink-500 dark:text-cream-300">
            Tudo num lugar só — do banco curado até a impressora da escola. Sem Word, sem copiar e
            colar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-terra-100 dark:bg-terra-700 -z-10" aria-hidden="true"></div>
          {STEPS.map((s, i) => {
            const Icon = s.icon
            return (
              <div
                key={s.step}
                data-reveal-item
                className={`${i > 0 ? `reveal-delay-${i} ` : ''}relative bg-cream-50 dark:bg-ink-700 rounded-caderno-sm border border-cream-400 dark:border-ink-500 p-6 shadow-caderno-md z-10`}
              >
                {s.step === 4 && (
                  <span
                    aria-hidden="true"
                    className="absolute -top-6 right-4 hidden md:block font-hand text-xl text-terra-500 rotate-2"
                  >
                    ↳ direto pra impressora
                  </span>
                )}
                <div className="flex items-baseline justify-center gap-3 mb-4">
                  <span aria-hidden="true" className="font-hand text-4xl text-terra-500 leading-none">
                    {s.step}
                  </span>
                  <h3 className="text-xl font-display text-ink-900 dark:text-cream-50">{s.title}</h3>
                </div>
                <p className="text-ink-500 dark:text-cream-300 text-center">{s.description}</p>
                <div className="mt-6 flex justify-center">
                  <Icon className="w-10 h-10 text-terra-500" aria-hidden="true" />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default ComoFuncionaSection
